import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { givePlan, topupBalance } from './actions';
import { OrganizersSliceState } from './index';

type ReducerBuilder = ActionReducerMapBuilder<OrganizersSliceState>;

// Баланс после пополнения и после выдачи плана перечитывается из RTK Query:
// вызывающий код инвалидирует тег 'Organizer' (balance.tsx, plans-block.tsx).
export function createTopupBalanceReducer(builder: ReducerBuilder) {
  builder.addCase(topupBalance.pending, (state) => {
    state.isProcessing = true;
    state.isProcessed = false;
    state.processName = 'topupBalance';
  });

  builder.addCase(topupBalance.fulfilled, (state) => {
    state.isProcessing = false;
    state.isProcessed = true;
    state.processName = undefined;
  });

  builder.addCase(topupBalance.rejected, (state) => {
    state.isProcessing = false;
    state.isProcessed = false;
  });
}

export function createGivePlanReducer(builder: ReducerBuilder) {
  builder.addCase(givePlan.pending, (state) => {
    state.isProcessing = true;
    state.isProcessed = false;
    state.processName = 'givePlan';
  });

  builder.addCase(givePlan.fulfilled, (state) => {
    state.isProcessing = false;
    state.isProcessed = true;
    state.processName = undefined;
  });

  builder.addCase(givePlan.rejected, (state) => {
    state.isProcessing = false;
    state.isProcessed = false;
  });
}
